// extracted by mini-css-extract-plugin
export default {"container":"container_container__sShEG","slim":"container_slim__hz1AE","addedPadding":"container_addedPadding__e98YO"};